import { reactive, toRefs } from "vue";
import {
	db,
	messaging
} from '../infraestructure/datasource'
import { BehaviorSubject } from 'rxjs';
import { NNotification } from "@/domain/entities/NNotification";
import useAuth from "./AuthState";
import { UserType } from "@/domain/entities/UserTypes";
// import { Doctor } from "@/domain/entities/Doctor";
// import { Patient } from "@/domain/entities/Patient";

const SECONDS = 1000
enum Level { INFO = "INFO", DANGER = "DANGER", WARNING = "WARNING" }

interface NotificationMessage {
	index: number,
	message: string,
	level: Level,
}
interface NotificationState {
	messages: NotificationMessage[],
	notifications: NNotification[],
	duration: number
	FCMToken: string | null,
	hasNewNotifications: boolean,
	hasPermissionPushNotification: boolean
}

const fcmTokenKey = 'messagingToken'
const state: NotificationState = reactive({
	messages: [],
	notifications: [],
	duration: 8 * SECONDS,
	FCMToken: window.localStorage.getItem(fcmTokenKey),
	hasNewNotifications: false,
	hasPermissionPushNotification: Notification.permission === 'granted'
});


const fcmTokenListener = new BehaviorSubject<typeof state.FCMToken>(state.FCMToken);

export default function useNotification() {
	interface SnackbarOptions {
		level: Level
	}
	const showSnackbar = (message: string, options?: SnackbarOptions | undefined) => {
		let length = state.messages.push({
			index: state.messages.length,
			message,
			level: options?.level || Level.INFO
		})
		const index = length - 1
		setTimeout(() => {
			deleteSnackbarAt(index)
		}, state.duration);
		return index
	};

	const deleteSnackbarAt = (index: number) => {
		let notifIndex = state.messages.findIndex((n) => n.index === index)
		if (notifIndex !== -1) state.messages.splice(notifIndex, 1)
	}

	const deleteAllSnackbar = () => {
		state.messages = []
	}

	const getMessagingToken = async (): Promise<any | undefined> => {
		try {
			let token = await messaging?.getToken()
			if (token) {
				const currentMessageToken = window.localStorage.getItem(fcmTokenKey)
				console.log('token will be updated', currentMessageToken != token)

				if (currentMessageToken != token) {
					await saveMessagingToken(token)
				}
			} else {
				console.log('No Instance ID token available. Request permission to generate one.');
				notificationsPermisionRequest();
			}
			showSnackbar('Sincronización finalizada', { level: Level.INFO })
			return
		} catch (err) {
			console.log('An error occurred while retrieving token. ', err);
			showSnackbar('Ocurrión un problema con la sincronización', { level: Level.DANGER })
			return err
		}
	}
	const notificationsPermisionRequest = () => {
		Notification.requestPermission()
			.then((result: NotificationPermission) => {
				state.hasPermissionPushNotification = result === 'granted'
				showSnackbar('Permiso otorgado', { level: Level.INFO })

				getMessagingToken();
			})
			.catch((err: any) => {
				console.log('Unable to get permission to notify.', err);
			});
	}
	const listenTokenRefresh = () => {
		const currentMessageToken = window.localStorage.getItem(fcmTokenKey)
		console.log('currentMessageToken', currentMessageToken);
		if (currentMessageToken) {
			messaging?.onTokenRefresh(function () {
				messaging?.getToken({ vapidKey: process.env.VUE_APP_FIREBASE_CM_KEY }).then(function (token) {
					saveMessagingToken(token);
				}).catch(function (err: Error) {
					console.log('Unable to retrieve refreshed token ', err);
				});
			});
		} else {
			fcmTokenListener.next(state.FCMToken)
			getMessagingToken()
		}
	}
	const saveMessagingToken = async (token: string) => {
		console.log('tokens', token)
		try {
			window.localStorage.setItem(fcmTokenKey, token)
			state.FCMToken = token
			fcmTokenListener.next(state.FCMToken)
		} catch (err) {
			console.log(err)
		}
	}

	// notifications located in firebase notif user data
	let notificationListening: undefined | any;
	const listenNotifications = async () => {
		const { user } = useAuth()
		if (notificationListening) {
			notificationListening()
		}
		let userGroup = user.value?.typeUser === UserType.Doctor ? 'doctors' : 'patients'
		let userId = user.value?.id

		notificationListening = db
			.collection(`${userGroup}/${userId}/notifications`)
			.orderBy('createdAt', 'desc').limit(20).onSnapshot((doc) => {
				state.notifications = doc.docs.map(d => ({ id: d.id, ...d.data() }) as NNotification)
				// if (user.value?.typeUser === UserType.Doctor) {
				// 	let doctor = doc.data() as Doctor
				// 	state.notifications = doctor.notifications || []
				// } else if (user.value?.typeUser === UserType.Patient) {
				// 	let patient = doc.data() as Patient
				// 	state.notifications = patient.notifications || []
				// }
			})
	}

	const listenOnMessage = () => {
		messaging?.onMessage((payload) => {
			console.log('[firebase-messaging-sw.js] Received on message ', payload);
			showSnackbar(payload.notification.title)
			state.hasNewNotifications = true
			// Customize notification here
		})
	}

	return {
		...toRefs(state),
		showSnackbar, deleteAllSnackbar, deleteSnackbarAt,
		getMessagingToken, notificationsPermisionRequest, listenTokenRefresh, saveMessagingToken, fcmTokenListener,
		listenNotifications, listenOnMessage, SnackbarMessageLevel: Level,
	};
}
